import styled from "styled-components";

export const MobileSideBarWrapper = styled.div`
  width: 100%;
  height: 76px;
  background: linear-gradient(0deg, #373636 0%, #373636 100%);
  display: flex;
  flex-direction: row;
  align-items: center;
  scrollbar-width: none;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 6px 0 25px;
  box-sizing: border-box;
`;

export const MobileSideBarItem = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 3px;
  > .icon-back {
    width: 29px;
    height: 29px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(p) => (p.isSelected ? "#fff" : "none")};
    > img {
      width: 13px;
      height: auto;
    }
  }

  > .title {
    color: ${(p) => (p.isSelected ? "#fff" : "#9C9C9C")};
    text-align: center;
    font-family: Pretendard;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    align-items: center;
  }
`;
